
// import React from "react";
// import { ShareIcon, RenameIcon, DeleteIcon, ProjectDetailsIcon } from "./MyProjectIcons";

// const ActionMenuPopover = ({
//   position, // We can ignore this prop's coordinates now, or remove it entirely from parent
//   onProjectDetails,
//   onShare,
//   isLastRow,
//   onRename,
//   onDelete,
//   menuRef,
// }) => {
//   return (
//     <div
//       // 1. Changed 'fixed' to 'absolute'
//       className="absolute z-[9999] bg-white rounded-xl shadow-[0_4px_20px_-4px_rgba(0,0,0,0.1)] p-2 min-w-[180px] flex flex-col gap-1 action-menu-container"
//       style={{
//         // If it's one of the last rows, attach it to the bottom, else the top
//         bottom: isLastRow ? '40px' : 'auto', 
//         top: isLastRow ? 'auto' : '40px',   
//         right: '40px', 
//       }}
//       ref={menuRef}
//     >
//       {/* Project Details */}
//       <div
//         onClick={onProjectDetails}
//         className="group flex items-center gap-3 px-3 py-2 rounded-lg border border-transparent hover:border-gray-200 hover:bg-[#C95EBE]/10 cursor-pointer transition-all duration-150 whitespace-nowrap"
//       >
//         <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-[#71717A] group-hover:text-[#C95EBE] transition-colors duration-150">
//           <ProjectDetailsIcon />
//         </div>
//         <span className="text-[15px] font-medium text-[#71717A] group-hover:text-[#C95EBE] transition-colors duration-150">
//           Project Details
//         </span>
//       </div>

//       {/* Share */}
//       <div
//         onClick={onShare}
//         className="group flex items-center gap-3 px-3 py-2 rounded-lg border border-transparent hover:border-gray-200 hover:bg-[#C95EBE]/10 cursor-pointer transition-all duration-150 whitespace-nowrap"
//       >
//         <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-[#71717A] group-hover:text-[#C95EBE] transition-colors duration-150">
//           <ShareIcon />
//         </div>
//         <span className="text-[15px] font-medium text-[#71717A] group-hover:text-[#C95EBE] transition-colors duration-150">
//           Share Project
//         </span>
//       </div>

//       {/* Rename */}
//       <div
//         onClick={onRename}
//         className="group flex items-center gap-3 px-3 py-2 rounded-lg border border-transparent hover:border-gray-200 hover:bg-[#C95EBE]/10 cursor-pointer transition-all duration-150 whitespace-nowrap"
//       >
//         <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-[#71717A] group-hover:text-[#C95EBE] transition-colors duration-150">
//           <RenameIcon />
//         </div>
//         <span className="text-[15px] font-medium text-[#71717A] group-hover:text-[#C95EBE] transition-colors duration-150">
//           Rename
//         </span>
//       </div>

//       {/* Delete */}
//       <div
//         onClick={onDelete}
//         className="group flex items-center gap-3 px-3 py-2 rounded-lg border border-transparent hover:border-gray-200 hover:bg-[#E21919]/10 cursor-pointer transition-all duration-150 whitespace-nowrap"
//       >
//         <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-[#71717A] group-hover:text-[#E21919] transition-colors duration-150">
//           <DeleteIcon />
//         </div>
//         <span className="text-[15px] font-medium text-[#71717A] group-hover:text-[#E21919] transition-colors duration-150">
//           Delete
//         </span>
//       </div>
//     </div>
//   );
// };

// export default ActionMenuPopover;

import React from "react";
import { createPortal } from "react-dom";
import { ShareIcon, RenameIcon, DeleteIcon, ProjectDetailsIcon, AddNotesIcon, ArchiveIcon, LeaveIcon, TransferIcon } from "./MyProjectIcons";

const MENU_ITEM_CLASS =
  "group flex items-center gap-3 px-3 py-2 rounded-lg border border-transparent hover:border-[#E4E4E7] hover:bg-[#F4F4F5] cursor-pointer transition-all duration-150 whitespace-nowrap";
const MENU_ICON_CLASS = "w-5 h-5 flex-shrink-0 flex items-center justify-center text-[#52525B]";
const MENU_LABEL_CLASS = "text-[15px] font-medium text-[#52525B]";

// `isOwner` / `canEdit` / `hasAccess` describe the current user's relationship to
// THIS project — the Projects table mixes owned rows, shared rows, and (for org
// admins) other members' projects listed for oversight.
//
//   owner                → full menu
//   editor               → Project Details, Add/Edit Note, Leave Project
//   reviewer             → Project Details, Leave Project
//   no access (oversight)→ a single "request access" hint; nothing is actionable
//
// Only someone who was granted access can leave a project, so Leave is hidden on
// oversight rows as well as on the user's own projects.
const ActionMenuPopover = ({
  position,
  onProjectDetails,
  onShare,
  onAddNotes,
  hasNote,
  onRename,
  onArchive,
  onDelete,
  onLeave,
  onTransferOwnership,
  isOwner = true,
  canEdit = true,
  hasAccess = true,
  canTransfer = false,
  ownerName = "",
  menuRef,
}) => {
  if (!hasAccess) {
    return createPortal(
      <div
        ref={menuRef}
        className="fixed z-[999999] bg-white rounded-xl shadow-[0_4px_20px_-4px_rgba(0,0,0,0.1)] p-3 w-[260px] border border-gray-100"
        style={{ top: `${position.top}px`, left: `${position.left}px` }}
        onClick={(e) => e.stopPropagation()}
      >
        {canTransfer ? (
          // The owner has left the workspace, so this project is frozen — no one
          // can rename, archive, delete or share it. Offer the way out.
          <>
            <p className="text-[13px] leading-snug text-[#71717A] font-outfit mb-2">
              {ownerName ? `${ownerName} is no longer in this workspace, so` : "This project's owner has left, so"}{" "}
              nobody can manage this project.
            </p>
            <div onClick={onTransferOwnership} className={MENU_ITEM_CLASS}>
              <div className={MENU_ICON_CLASS}>
                <TransferIcon />
              </div>
              <span className={MENU_LABEL_CLASS}>Transfer ownership</span>
            </div>
          </>
        ) : (
          <p className="text-[13px] leading-snug text-[#71717A] font-outfit">
            You can see this project as a workspace admin, but you have no access to it.
            {ownerName ? ` Ask ${ownerName} to share it with you.` : " Ask its owner to share it with you."}
          </p>
        )}
      </div>,
      document.body
    );
  }

  // Render the menu at the root of the document to escape table overflow constraints
  return createPortal(
    <div
      ref={menuRef}
      // Use fixed positioning and high z-index
      className="fixed z-[999999] bg-white rounded-xl shadow-[0_4px_20px_-4px_rgba(0,0,0,0.1)] p-2 min-w-[180px] flex flex-col gap-1 border border-gray-100"
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
      }}
      // Stop clicks inside the menu from propagating to the table row
      onClick={(e) => e.stopPropagation()}
    >
      {/* Project Details */}
      <div onClick={onProjectDetails} className={MENU_ITEM_CLASS}>
        <div className={MENU_ICON_CLASS}>
          <ProjectDetailsIcon />
        </div>
        <span className={MENU_LABEL_CLASS}>Project Details</span>
      </div>

      {/* Share */}
      {isOwner && (
        <div onClick={onShare} className={MENU_ITEM_CLASS}>
          <div className={MENU_ICON_CLASS}>
            <ShareIcon />
          </div>
          <span className={MENU_LABEL_CLASS}>Share Project</span>
        </div>
      )}

      {/* Add / Edit Note */}
      {canEdit && (
        <div onClick={onAddNotes} className={MENU_ITEM_CLASS}>
          <div className={MENU_ICON_CLASS}>
            <AddNotesIcon />
          </div>
          <span className={MENU_LABEL_CLASS}>{hasNote ? "Edit Note" : "Add Note"}</span>
        </div>
      )}

      {/* Rename */}
      {isOwner && (
        <div onClick={onRename} className={MENU_ITEM_CLASS}>
          <div className={MENU_ICON_CLASS}>
            <RenameIcon />
          </div>
          <span className={MENU_LABEL_CLASS}>Rename</span>
        </div>
      )}

      {/* Transfer ownership — owner handing over voluntarily */}
      {isOwner && canTransfer && (
        <div onClick={onTransferOwnership} className={MENU_ITEM_CLASS}>
          <div className={MENU_ICON_CLASS}>
            <TransferIcon />
          </div>
          <span className={MENU_LABEL_CLASS}>Transfer ownership</span>
        </div>
      )}

      {/* Archive */}
      {isOwner && (
        <div onClick={onArchive} className={MENU_ITEM_CLASS}>
          <div className={MENU_ICON_CLASS}>
            <ArchiveIcon />
          </div>
          <span className={MENU_LABEL_CLASS}>Archive Project</span>
        </div>
      )}

      {/* Delete */}
      {isOwner && (
        <div onClick={onDelete} className={MENU_ITEM_CLASS}>
          <div className={MENU_ICON_CLASS}>
            <DeleteIcon />
          </div>
          <span className={MENU_LABEL_CLASS}>Delete</span>
        </div>
      )}

      {/* Leave — shared projects only; an owner can't leave their own project. */}
      {!isOwner && (
        <div onClick={onLeave} className={MENU_ITEM_CLASS}>
          <div className={MENU_ICON_CLASS}>
            <LeaveIcon />
          </div>
          <span className={MENU_LABEL_CLASS}>Leave Project</span>
        </div>
      )}
    </div>,
    document.body // Attach to body
  );
};

export default ActionMenuPopover;